import styled from "styled-components"

export const CoursesContainer = styled.div`
  margin-bottom: 0;
  @media (max-width: 480px) {
    margin-bottom: 40px;
  }
`
export const CoursesTitle = styled.h2`
  font-family: "Roboto Slab";
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 37px;
  color: #000000;
  margin-bottom: 30px;
`
